import { Link } from "react-router-dom";
import { IMAGES, scrollTo } from "@/lib/api";

export const Hero = () => (
  <section data-testid="hero-section" className="relative md:min-h-screen flex flex-col md:flex-row md:items-center pt-16 md:pt-0">
    <div className="absolute top-0 inset-x-0 z-20 flex justify-between px-6 md:px-10 py-6 font-cinzel text-[11px] tracking-[0.3em] uppercase text-[#f7f1e1]/80">
      <span data-testid="header-brand">Queen Boyce</span>
      <Link to="/owner" data-testid="header-owner-link" className="hover:text-[#d4af37] transition-colors">Owner</Link>
    </div>
    <div className="relative w-full aspect-[1264/848] md:aspect-auto md:absolute md:top-0 md:right-0 md:h-full md:w-[60%]">
      <img src={IMAGES.hero} alt="Black family with golden angel wings under the sun, moon and stars in a purple and blue sky" className="w-full h-full object-cover" data-testid="hero-image" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#070d2b] via-transparent to-transparent md:bg-gradient-to-r md:from-[#070d2b] md:via-[#070d2b]/10 md:to-transparent" />
    </div>
    <div className="relative z-10 px-6 md:px-16 pt-8 md:pt-0 pb-16 md:pb-0 max-w-2xl md:w-[50%] rise">
      <p className="eyebrow">Welcome, beloved soul</p>
      <h1 data-testid="hero-title" className="font-display gold-text text-5xl sm:text-6xl lg:text-7xl mt-4 leading-tight">Earth Angel</h1>
      <p className="font-cinzel text-base md:text-lg mt-4 text-[#f7f1e1]/90">The Chosen Star Seed Healer and Teacher</p>
      <div className="gold-line w-40 my-7" />
      <p className="italic text-2xl md:text-3xl text-[#f1d57a]">"Transmute pain into purpose"</p>
      <div className="flex flex-wrap gap-4 mt-10">
        <button data-testid="hero-request-session-btn" className="btn-gold" onClick={() => scrollTo("pricing")}>Request a Session</button>
        <button data-testid="hero-journey-btn" className="btn-ghost" onClick={() => scrollTo("journey")}>My Journey</button>
      </div>
    </div>
  </section>
);
